import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "subheader col-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "売上先マスタ編集")
], -1)
const _hoisted_4 = { class: "subheader-block ml-auto demo" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-xl-12" }
const _hoisted_15 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "編集項目"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1)
const _hoisted_17 = {
  class: "panel-container show",
  id: "panel-editers"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1)
const _hoisted_19 = { class: "panel-content contents" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "売上先コード", -1)
const _hoisted_22 = { class: "col-md-5 contCnt" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "売上先名", -1)
const _hoisted_25 = { class: "col-md-5 contCnt" }
const _hoisted_26 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "売上先名(英語)", -1)
const _hoisted_29 = { class: "col-md-5 contCnt" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "ふりがな", -1)
const _hoisted_32 = { class: "col-md-5 contCnt" }
const _hoisted_33 = {
  key: 0,
  class: "error-message4vali"
}
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "会社種類", -1)
const _hoisted_36 = { class: "col-md-5 contCnt" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "表記", -1)
const _hoisted_39 = { class: "col-md-5 contCnt" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "郵便番号", -1)
const _hoisted_42 = { class: "col-md-5 contCnt" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "TEL", -1)
const _hoisted_45 = { class: "col-md-5 contCnt" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "FAX", -1)
const _hoisted_48 = { class: "col-md-5 contCnt" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "住所1", -1)
const _hoisted_51 = { class: "col-md-5 contCnt" }
const _hoisted_52 = { class: "row" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "住所2", -1)
const _hoisted_54 = { class: "col-md-5 contCnt" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, null, -1)
const _hoisted_57 = { class: "col-md-5 contCnt" }
const _hoisted_58 = { class: "custom-control custom-checkbox" }
const _hoisted_59 = ["checked"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "cbClaimadd"
}, "請求書送付先同住所", -1)
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "請求書送付先住所1", -1)
const _hoisted_63 = { class: "col-md-5 contCnt" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "請求書送付先住所2", -1)
const _hoisted_66 = { class: "col-md-5 contCnt" }
const _hoisted_67 = { class: "row" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "請求書言語", -1)
const _hoisted_69 = { class: "col-md-5 contCnt" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "支払サイト", -1)
const _hoisted_72 = { class: "col-md-5 contCnt selectedClear" }
const _hoisted_73 = { class: "row" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "顧客担当者", -1)
const _hoisted_75 = { class: "col-md-5 contCnt" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "顧客担当者ふりがな", -1)
const _hoisted_78 = { class: "col-md-5 contCnt" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "顧客部署", -1)
const _hoisted_81 = { class: "col-md-5 contCnt" }
const _hoisted_82 = { class: "row" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "役職", -1)
const _hoisted_84 = { class: "col-md-5 contCnt" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "メールアドレス", -1)
const _hoisted_87 = { class: "col-md-5 contCnt" }
const _hoisted_88 = { class: "row" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "サブメールアドレス１", -1)
const _hoisted_90 = { class: "col-md-5 contCnt" }
const _hoisted_91 = { class: "row" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "サブメールアドレス２", -1)
const _hoisted_93 = { class: "col-md-5 contCnt" }
const _hoisted_94 = { class: "row" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "サブメールアドレス３", -1)
const _hoisted_96 = { class: "col-md-5 contCnt" }
const _hoisted_97 = { class: "row" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "備考", -1)
const _hoisted_99 = { class: "col-md-5 contCnt" }
const _hoisted_100 = { class: "row" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "表示順", -1)
const _hoisted_102 = { class: "col-md-5 contCnt" }
const _hoisted_103 = { class: "row" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "ジャンル", -1)
const _hoisted_105 = { class: "col-md-5 contCnt" }
const _hoisted_106 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "genreDairiten"
}, "代理店", -1)
const _hoisted_108 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "genreTyoku"
}, "直クライアント", -1)
const _hoisted_110 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "genreSonota"
}, "その他", -1)
const _hoisted_112 = { class: "row" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1 contTitle" }, "業種", -1)
const _hoisted_114 = { class: "col-md-2 contCnt" }
const _hoisted_115 = { class: "custom-control custom-checkbox" }
const _hoisted_116 = ["checked"]
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckKoukoku"
}, "広告", -1)
const _hoisted_118 = { class: "custom-control custom-checkbox" }
const _hoisted_119 = ["checked"]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSeizou"
}, "製造/製作", -1)
const _hoisted_121 = { class: "custom-control custom-checkbox" }
const _hoisted_122 = ["checked"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckInsatu"
}, "印刷", -1)
const _hoisted_124 = { class: "custom-control custom-checkbox" }
const _hoisted_125 = ["checked"]
const _hoisted_126 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckIbent"
}, "イベント", -1)
const _hoisted_127 = { class: "custom-control custom-checkbox" }
const _hoisted_128 = ["checked"]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckTuusin"
}, "通信/放送サービス", -1)
const _hoisted_130 = { class: "custom-control custom-checkbox" }
const _hoisted_131 = ["checked"]
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckFashon"
}, "ファッション", -1)
const _hoisted_133 = { class: "custom-control custom-checkbox" }
const _hoisted_134 = ["checked"]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckBiyou"
}, "美容", -1)
const _hoisted_136 = { class: "custom-control custom-checkbox" }
const _hoisted_137 = ["checked"]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckKesyouhin"
}, "化粧品", -1)
const _hoisted_139 = { class: "col-md-2 contCnt" }
const _hoisted_140 = { class: "custom-control custom-checkbox" }
const _hoisted_141 = ["checked"]
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckTanmatu"
}, "端末", -1)
const _hoisted_143 = { class: "custom-control custom-checkbox" }
const _hoisted_144 = ["checked"]
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckKaden"
}, "家電", -1)
const _hoisted_146 = { class: "custom-control custom-checkbox" }
const _hoisted_147 = ["checked"]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckJidousya"
}, "自動車/バイク", -1)
const _hoisted_149 = { class: "custom-control custom-checkbox" }
const _hoisted_150 = ["checked"]
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckOngaku"
}, "音楽", -1)
const _hoisted_152 = { class: "custom-control custom-checkbox" }
const _hoisted_153 = ["checked"]
const _hoisted_154 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSupotu"
}, "スポーツ", -1)
const _hoisted_155 = { class: "custom-control custom-checkbox" }
const _hoisted_156 = ["checked"]
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckRyoko"
}, "旅行", -1)
const _hoisted_158 = { class: "custom-control custom-checkbox" }
const _hoisted_159 = ["checked"]
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckGemu"
}, "ゲーム", -1)
const _hoisted_161 = { class: "custom-control custom-checkbox" }
const _hoisted_162 = ["checked"]
const _hoisted_163 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSyoseki"
}, "書籍", -1)
const _hoisted_164 = { class: "col-md-2 contCnt" }
const _hoisted_165 = { class: "custom-control custom-checkbox" }
const _hoisted_166 = ["checked"]
const _hoisted_167 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckEiga"
}, "映画", -1)
const _hoisted_168 = { class: "custom-control custom-checkbox" }
const _hoisted_169 = ["checked"]
const _hoisted_170 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSyokuhin"
}, "食品", -1)
const _hoisted_171 = { class: "custom-control custom-checkbox" }
const _hoisted_172 = ["checked"]
const _hoisted_173 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckInryou"
}, "飲料", -1)
const _hoisted_174 = { class: "custom-control custom-checkbox" }
const _hoisted_175 = ["checked"]
const _hoisted_176 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckGaisyoku"
}, "外食", -1)
const _hoisted_177 = { class: "custom-control custom-checkbox" }
const _hoisted_178 = ["checked"]
const _hoisted_179 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckUnyu"
}, "運輸・観光", -1)
const _hoisted_180 = { class: "custom-control custom-checkbox" }
const _hoisted_181 = ["checked"]
const _hoisted_182 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckKyouiku"
}, "教育", -1)
const _hoisted_183 = { class: "custom-control custom-checkbox" }
const _hoisted_184 = ["checked"]
const _hoisted_185 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckIryou"
}, "医療/医薬", -1)
const _hoisted_186 = { class: "custom-control custom-checkbox" }
const _hoisted_187 = ["checked"]
const _hoisted_188 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSyouken"
}, "証券", -1)
const _hoisted_189 = { class: "col-md-2 contCnt" }
const _hoisted_190 = { class: "custom-control custom-checkbox" }
const _hoisted_191 = ["checked"]
const _hoisted_192 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckHudousan"
}, "不動産", -1)
const _hoisted_193 = { class: "custom-control custom-checkbox" }
const _hoisted_194 = ["checked"]
const _hoisted_195 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckKinyu"
}, "金融/保険", -1)
const _hoisted_196 = { class: "custom-control custom-checkbox" }
const _hoisted_197 = ["checked"]
const _hoisted_198 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSyouhisyakinyuu"
}, "消費者金融", -1)
const _hoisted_199 = { class: "custom-control custom-checkbox" }
const _hoisted_200 = ["checked"]
const _hoisted_201 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckKantyou"
}, "官庁", -1)
const _hoisted_202 = { class: "custom-control custom-checkbox" }
const _hoisted_203 = ["checked"]
const _hoisted_204 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSeiji"
}, "政治/宗教", -1)
const _hoisted_205 = { class: "custom-control custom-checkbox" }
const _hoisted_206 = ["checked"]
const _hoisted_207 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckMatting"
}, "マッチング", -1)
const _hoisted_208 = { class: "custom-control custom-checkbox" }
const _hoisted_209 = ["checked"]
const _hoisted_210 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckGyanburu"
}, "ギャンブル", -1)
const _hoisted_211 = { class: "custom-control custom-checkbox" }
const _hoisted_212 = ["checked"]
const _hoisted_213 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "ckSonota"
}, "その他", -1)
const _hoisted_214 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1)
const _hoisted_215 = { class: "text-success fw-500" }
const _hoisted_216 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_220 = { class: "modal-footer" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_223 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add())),
              disabled: _ctx.btnDisable,
              class: "btn btn-info waves-effect waves-themed"
            }, [
              _hoisted_6,
              _createTextVNode("追加 ")
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.upd(false))),
              disabled: _ctx.btnDisable,
              class: "btn btn-info waves-effect waves-themed"
            }, [
              _hoisted_8,
              _createTextVNode("登録 ")
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.delConf())),
              disabled: _ctx.btnDisable,
              class: "btn btn-danger waves-effect waves-themed"
            }, [
              _hoisted_10,
              _createTextVNode("削除 ")
            ], 8, _hoisted_9))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/uriagesakilist')))
        }, [
          _hoisted_12,
          _createTextVNode("戻る ")
        ], 8, _hoisted_11)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClientCd",
                    class: "form-control form-control-sm",
                    disabled: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.delegate.c_client_id) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClientNm",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.delegate.c_client_name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_name]
                  ]),
                  (_ctx.errors?.path === 'clientName')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClientNm",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.delegate.c_client_name_en) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_name_en]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtFurigana",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.delegate.c_client_name_pt) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_name_pt]
                  ]),
                  (_ctx.errors?.path === 'furigana')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.errors.message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4CompanyType,
                    modelValue: _ctx.delegate.c_client_company_type,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.delegate.c_client_company_type) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4SignagePosi,
                    modelValue: _ctx.delegate.c_client_flag_company_signage_posi,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.delegate.c_client_flag_company_signage_posi) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtYubin",
                    class: "form-control form-control-sm",
                    maxlength: "8",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.delegate.c_client_zip) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_zip]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtTel",
                    class: "form-control form-control-sm",
                    maxlength: "13",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.delegate.c_client_tel) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_tel]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtFax",
                    class: "form-control form-control-sm",
                    maxlength: "13",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.delegate.c_client_fax) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_fax]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtAdd1",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.delegate.c_client_address_1) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_address_1]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtAdd2",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.delegate.c_client_address_2) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_address_2]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "cbClaimadd",
                      checked: (_ctx.delegate.c_client_flag_claim_addon as any),
                      onChange: _cache[15] || (_cache[15] = ($event: any) => (
                        _ctx.delegate.c_client_flag_claim_addon = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_59),
                    _hoisted_60
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClaimAdd1",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.delegate.c_client_claim_address_1) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_claim_address_1]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("div", _hoisted_66, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtClaimAdd2",
                    class: "form-control form-control-sm",
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.delegate.c_client_claim_address_2) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_claim_address_2]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4PClaimLanguage,
                    modelValue: _ctx.delegate.c_client_claim_language,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.delegate.c_client_claim_language) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4PaymentSite,
                    modelValue: _ctx.delegate.c_client_paysite,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.delegate.c_client_paysite) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createElementVNode("div", _hoisted_75, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtUserNm",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.delegate.c_client_staff_name) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_staff_name]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _createElementVNode("div", _hoisted_78, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtUserFurigana",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.delegate.c_client_staff_name_pt) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_staff_name_pt]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _hoisted_80,
                _createElementVNode("div", _hoisted_81, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtBusyo",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.delegate.c_client_depart) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_depart]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                _createElementVNode("div", _hoisted_84, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtYakusyoku",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.delegate.c_client_post) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_post]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                _hoisted_86,
                _createElementVNode("div", _hoisted_87, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtMail",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.delegate.c_client_main_mail) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_main_mail]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_88, [
                _hoisted_89,
                _createElementVNode("div", _hoisted_90, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtSubMail1",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.delegate.c_client_sub_mail1) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_sub_mail1]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_91, [
                _hoisted_92,
                _createElementVNode("div", _hoisted_93, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtSubMail2",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.delegate.c_client_sub_mail2) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_sub_mail2]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", _hoisted_96, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtSubMail3",
                    class: "form-control form-control-sm",
                    maxlength: "50",
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.delegate.c_client_sub_mail3) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_sub_mail3]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _hoisted_98,
                _createElementVNode("div", _hoisted_99, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtBiko",
                    class: "form-control form-control-sm",
                    maxlength: "1000",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.delegate.c_client_remarks) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_remarks]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _hoisted_101,
                _createElementVNode("div", _hoisted_102, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtDispOrder",
                    class: "form-control form-control-sm",
                    maxlength: "5",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.delegate.c_client_show_order) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_client_show_order]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_103, [
                _hoisted_104,
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("div", _hoisted_106, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "genreDairiten",
                      name: "radioGenre",
                      value: "1",
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.delegate.c_client_genre) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.delegate.c_client_genre]
                    ]),
                    _hoisted_107
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "genreTyoku",
                      name: "radioGenre",
                      value: "2",
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.delegate.c_client_genre) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.delegate.c_client_genre]
                    ]),
                    _hoisted_109
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      class: "custom-control-input",
                      id: "genreSonota",
                      name: "radioGenre",
                      value: "3",
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.delegate.c_client_genre) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.delegate.c_client_genre]
                    ]),
                    _hoisted_111
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                _hoisted_113,
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckKoukoku",
                      checked: (_ctx.delegate.c_client_flag_type_ad as any),
                      onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.delegate.c_client_flag_type_ad = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_116),
                    _hoisted_117
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSeizou",
                      checked: (_ctx.delegate.c_client_flag_type_mfg as any),
                      onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.delegate.c_client_flag_type_mfg = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_119),
                    _hoisted_120
                  ]),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckInsatu",
                      checked: (_ctx.delegate.c_client_flag_type_print as any),
                      onChange: _cache[35] || (_cache[35] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_print = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_122),
                    _hoisted_123
                  ]),
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckIbent",
                      checked: (_ctx.delegate.c_client_flag_type_event as any),
                      onChange: _cache[36] || (_cache[36] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_event = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_125),
                    _hoisted_126
                  ]),
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckTuusin",
                      checked: (_ctx.delegate.c_client_flag_type_comm as any),
                      onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.delegate.c_client_flag_type_comm = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_128),
                    _hoisted_129
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckFashon",
                      checked: (_ctx.delegate.c_client_flag_type_fashion as any),
                      onChange: _cache[38] || (_cache[38] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_fashion = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_131),
                    _hoisted_132
                  ]),
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckBiyou",
                      checked: (_ctx.delegate.c_client_flag_type_beauty as any),
                      onChange: _cache[39] || (_cache[39] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_beauty = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_134),
                    _hoisted_135
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckKesyouhin",
                      checked: (_ctx.delegate.c_client_flag_type_cosmetic as any),
                      onChange: _cache[40] || (_cache[40] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_cosmetic = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_137),
                    _hoisted_138
                  ])
                ]),
                _createElementVNode("div", _hoisted_139, [
                  _createElementVNode("div", _hoisted_140, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckTanmatu",
                      checked: (_ctx.delegate.c_client_flag_type_device as any),
                      onChange: _cache[41] || (_cache[41] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_device = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_141),
                    _hoisted_142
                  ]),
                  _createElementVNode("div", _hoisted_143, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckKaden",
                      checked: (_ctx.delegate.c_client_flag_type_appliance as any),
                      onChange: _cache[42] || (_cache[42] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_appliance = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_144),
                    _hoisted_145
                  ]),
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckJidousya",
                      checked: (_ctx.delegate.c_client_flag_type_caretc as any),
                      onChange: _cache[43] || (_cache[43] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_caretc = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_147),
                    _hoisted_148
                  ]),
                  _createElementVNode("div", _hoisted_149, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckOngaku",
                      checked: (_ctx.delegate.c_client_flag_type_music as any),
                      onChange: _cache[44] || (_cache[44] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_music = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_150),
                    _hoisted_151
                  ]),
                  _createElementVNode("div", _hoisted_152, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSupotu",
                      checked: (_ctx.delegate.c_client_flag_type_sport as any),
                      onChange: _cache[45] || (_cache[45] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_sport = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_153),
                    _hoisted_154
                  ]),
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckRyoko",
                      checked: (_ctx.delegate.c_client_flag_type_trip as any),
                      onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.delegate.c_client_flag_type_trip = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_156),
                    _hoisted_157
                  ]),
                  _createElementVNode("div", _hoisted_158, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckGemu",
                      checked: (_ctx.delegate.c_client_flag_type_game as any),
                      onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.delegate.c_client_flag_type_game = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_159),
                    _hoisted_160
                  ]),
                  _createElementVNode("div", _hoisted_161, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSyoseki",
                      checked: (_ctx.delegate.c_client_flag_type_book as any),
                      onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.delegate.c_client_flag_type_book = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_162),
                    _hoisted_163
                  ])
                ]),
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("div", _hoisted_165, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckEiga",
                      checked: (_ctx.delegate.c_client_flag_type_movie as any),
                      onChange: _cache[49] || (_cache[49] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_movie = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_166),
                    _hoisted_167
                  ]),
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSyokuhin",
                      checked: (_ctx.delegate.c_client_flag_type_food as any),
                      onChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.delegate.c_client_flag_type_food = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_169),
                    _hoisted_170
                  ]),
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckInryou",
                      checked: (_ctx.delegate.c_client_flag_type_drink as any),
                      onChange: _cache[51] || (_cache[51] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_drink = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_172),
                    _hoisted_173
                  ]),
                  _createElementVNode("div", _hoisted_174, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckGaisyoku",
                      checked: (_ctx.delegate.c_client_flag_type_eatout as any),
                      onChange: _cache[52] || (_cache[52] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_eatout = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_175),
                    _hoisted_176
                  ]),
                  _createElementVNode("div", _hoisted_177, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckUnyu",
                      checked: (_ctx.delegate.c_client_flag_type_transpt as any),
                      onChange: _cache[53] || (_cache[53] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_transpt = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_178),
                    _hoisted_179
                  ]),
                  _createElementVNode("div", _hoisted_180, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckKyouiku",
                      checked: (_ctx.delegate.c_client_flag_type_edu as any),
                      onChange: _cache[54] || (_cache[54] = ($event: any) => (_ctx.delegate.c_client_flag_type_edu = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_181),
                    _hoisted_182
                  ]),
                  _createElementVNode("div", _hoisted_183, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckIryou",
                      checked: (_ctx.delegate.c_client_flag_type_medical as any),
                      onChange: _cache[55] || (_cache[55] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_medical = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_184),
                    _hoisted_185
                  ]),
                  _createElementVNode("div", _hoisted_186, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSyouken",
                      checked: (_ctx.delegate.c_client_flag_type_stock as any),
                      onChange: _cache[56] || (_cache[56] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_stock = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_187),
                    _hoisted_188
                  ])
                ]),
                _createElementVNode("div", _hoisted_189, [
                  _createElementVNode("div", _hoisted_190, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckHudousan",
                      checked: (_ctx.delegate.c_client_flag_type_realty as any),
                      onChange: _cache[57] || (_cache[57] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_realty = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_191),
                    _hoisted_192
                  ]),
                  _createElementVNode("div", _hoisted_193, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckKinyu",
                      checked: (_ctx.delegate.c_client_flag_type_insure as any),
                      onChange: _cache[58] || (_cache[58] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_insure = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_194),
                    _hoisted_195
                  ]),
                  _createElementVNode("div", _hoisted_196, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSyouhisyakinyuu",
                      checked: (_ctx.delegate.c_client_flag_type_cfpa as any),
                      onChange: _cache[59] || (_cache[59] = ($event: any) => (_ctx.delegate.c_client_flag_type_cfpa = _ctx.cnvCb($event)))
                    }, null, 40, _hoisted_197),
                    _hoisted_198
                  ]),
                  _createElementVNode("div", _hoisted_199, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckKantyou",
                      checked: (_ctx.delegate.c_client_flag_type_govtofc as any),
                      onChange: _cache[60] || (_cache[60] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_govtofc = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_200),
                    _hoisted_201
                  ]),
                  _createElementVNode("div", _hoisted_202, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSeiji",
                      checked: (_ctx.delegate.c_client_flag_type_politics as any),
                      onChange: _cache[61] || (_cache[61] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_politics = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_203),
                    _hoisted_204
                  ]),
                  _createElementVNode("div", _hoisted_205, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckMatting",
                      checked: (_ctx.delegate.c_client_flag_type_matching as any),
                      onChange: _cache[62] || (_cache[62] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_matching = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_206),
                    _hoisted_207
                  ]),
                  _createElementVNode("div", _hoisted_208, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckGyanburu",
                      checked: (_ctx.delegate.c_client_flag_type_gamble as any),
                      onChange: _cache[63] || (_cache[63] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_gamble = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_209),
                    _hoisted_210
                  ]),
                  _createElementVNode("div", _hoisted_211, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "custom-control-input",
                      id: "ckSonota",
                      checked: (_ctx.delegate.c_client_flag_type_others as any),
                      onChange: _cache[64] || (_cache[64] = ($event: any) => (
                        _ctx.delegate.c_client_flag_type_others = _ctx.cnvCb($event)
                      ))
                    }, null, 40, _hoisted_212),
                    _hoisted_213
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[65] || (_cache[65] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_214,
        _createElementVNode("span", _hoisted_215, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_216
      ]),
      footer: _withCtx(() => [
        _hoisted_217
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _hoisted_218,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_219
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_220, [
          _createElementVNode("button", {
            onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.del())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_221,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_222
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_223, [
          _createElementVNode("button", {
            onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}